var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlyph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 60C13.4516 60 0 46.5484 0 30C0 13.4516 13.4516 0 30 0C46.5484 0 60 13.4516 60 30C60 46.5484 46.5484 60 30 60ZM30 7.25806C17.4677 7.25806 7.25806 17.4677 7.25806 30C7.25806 42.5323 17.4677 52.7419 30 52.7419C42.5323 52.7419 52.7419 42.5323 52.7419 30C52.7419 17.4677 42.5323 7.25806 30 7.25806Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5474 22.4531H29.0312V23.7112C29.0312 24.4031 29.5974 24.9693 30.2893 24.9693C30.9813 24.9693 31.5474 24.4031 31.5474 23.7112V22.4531Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7422 17.4219V19.938H24.0003V23.7122C24.0003 27.1719 26.8309 30.0025 30.2906 30.0025C26.8309 30.0025 24.0003 32.8332 24.0003 36.2928V40.067H22.7422V42.5832H37.839V40.067H36.5809V36.2928C36.5809 32.8332 33.7503 30.0025 30.2906 30.0025C33.7503 30.0025 36.5809 27.1719 36.5809 23.7122V19.938H37.839V17.4219H22.7422ZM26.5164 19.938H34.0648V23.7122C34.0648 25.788 32.3664 27.4864 30.2906 27.4864C28.2148 27.4864 26.5164 25.788 26.5164 23.7122V19.938ZM26.5164 36.2928V40.067H34.0648V36.2928C34.0648 34.217 32.3664 32.5186 30.2906 32.5186C28.2148 32.5186 26.5164 34.217 26.5164 36.2928Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlyph);
export default __webpack_public_path__ + "static/media/glyph.4733ea37c45a7293097bcafcad755ab4.svg";
export { ForwardRef as ReactComponent };